import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";

// services
import { useUpdateModuleStatusMutation } from "../../store/services/moduleServerApi";
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_1_1_3 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  const [
    updateModuleStatus,
    {
      isLoading,
      error: { data: { message: errorMessage } = {} } = {},
      data: { message: successMessage } = {},
    },
  ] = useUpdateModuleStatusMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    updateModuleStatus({ moduleNo: 1, end: 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section className="mb-5">
            <h1 className="blue text-uppercase b mt-5">1.3.6 Module Summary</h1>
            <p className="mt-1 mb-0">Estimated time to complete: 1 minute</p>
          </section>
          <section className="mb-5 row">
            <div className="col-sm-12">
              <h2 className="text-uppercase b mb-3">
                <span className="orange">Congratulations!</span> You have
                completed Module 1: Learn about Alzheimer's disease (AD), its
                underlying neuropathology, and the role of Amyvid.
              </h2>
              <p>
                Continue to Module 2 to learn about the method for accurate
                interpretation of Amyvid PET images.
              </p>
            </div>
          </section>
          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-1/module-1-3-5", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/overview", "_self");
              }}
            >
              Continue
            </LdsButton>
          </section>
        </main>
      </div>
    </div>
  );
};

export default Module_1_1_3;
